const men = [
  {
    id: 1,
    name: 'Polo',
    description: 'Polo collar t-shirt',
    image: 'pinksh.png',
    price: {
      USD: 80.16,
      NOK: 130.23,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 2,
    name: 'Henley',
    description: 'Henley collar T-shirt',
    image: 'jean.png',
    price: {
      USD: 99.55,
      NOK: 118.42,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 3,
    name: 'Ringer',
    description: 'Fanny pack synthetic black',
    image: 'pinkshirt.png',
    price: {
      USD: 75.20,
      NOK: 90.96,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 4,
    name: 'LACOSTE',
    description: 'Textured brand shirt',
    image: 'orsh.png',
    price: {
      USD: 85.95,
      NOK: 95.43,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 5,
    name: 'Pocket',
    description: 'Solid designer shirt',
    image: 'capsh.png',
    price: {
      USD: 200.04,
      NOK: 267.50,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 6,
    name: 'Emporio Armani',
    description: 'Roberta Handbag polyester',
    image: 'tsh.png',
    price: {
      USD: 90.92,
      NOK: 110.54,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 7,
    name: 'Van Heusen',
    description: 'Women Solid Laptop Bag',
    image: 'lasts.png',
    price: {
      USD: 120.23,
      NOK: 140.63,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 8,
    name: 'Raglan',
    description: 'Raglan sleeve t-shirt',
    image: 'tshi.png',
    price: {
      USD: 50.94,
      NOK: 70.29,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 9,
    name: 'Douche bag',
    description: 'Douche bag neck t-shirt',
    image: 'grsh.png',
    price: {
      USD: 89.15,
      NOK: 105.53,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 10,
    name: 'Yoke',
    description: 'Yoke neck t-shirts',
    image: 'bluish.png',
    price: {
      USD: 100.55,
      NOK: 120.53,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 11,
    name: 'Baggit',
    description: 'Women Solid Sling Bag',
    image: 'greensh.png',
    price: {
      USD: 55.61,
      NOK: 75.74,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 12,
    name: 'Coach',
    description: 'Charlie Handbag Nappa leather',
    image: 'blacksh.png',
    price: {
      USD: 70.95,
      NOK: 90.53,
    },
    category: 'men',
    type: 'shirt',
  },
  {
    id: 13,
    name: 'Shoes',
    description: 'Thelma Tote bag synthetic black',
    image: 'bt.png',
    price: {
      USD: 188.66,
      NOK: 250.99,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 14,
    name: 'Shoes',
    description: 'Animal PU Structure Satchel',
    image: 'blx.png',
    price: {
      USD: 120.55,
      NOK: 318.42,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 15,
    name: 'Shoes',
    description: 'Fanny pack synthetic black',
    image: 'bt.png',
    price: {
      USD: 135.20,
      NOK: 150.96,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 16,
    name: 'Shoes',
    description: 'Textured Handheld Bag',
    image: 'cam.png',
    price: {
      USD: 120.55,
      NOK: 145.93,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 17,
    name: 'Shoes',
    description: 'Solid Handheld Bag',
    image: 'la.png',
    price: {
      USD: 115.04,
      NOK: 136.50,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 18,
    name: 'Shoes',
    description: 'Roberta Handbag polyester',
    image: 'men.png',
    price: {
      USD: 90.92,
      NOK: 110.54,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 19,
    name: 'Shoes',
    description: 'Women Solid Laptop Bag',
    image: 'nik.png',
    price: {
      USD: 110.23,
      NOK: 130.63,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 20,
    name: 'Shoes',
    description: 'Women Zip around Bag',
    image: 'sh.png',
    price: {
      USD: 99.94,
      NOK: 120.29,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 21,
    name: 'Shoes',
    description: 'Animal PU Structure Satchel',
    image: 'sne.png',
    price: {
      USD: 89.15,
      NOK: 110.33,
    },
    category: 'men',
    type: 'men shoes',
  },
  {
    id: 22,
    name: 'Shoes',
    description: 'Charlie Handbag Nappa leather',
    image: 'squ.png',
    price: {
      USD: 110.77,
      NOK: 112.47,
    },
    category: 'men',
    type: 'men shoes',
  },
];

export default men;
